<template>
    <div class="footer-content">
        <iframe id="iframe" src="https://bulletin.cebpubservice.com/footer.html" frameborder="no" scrolling="no" style="width: 100%; overflow: hidden; height: 170px;"></iframe>
    </div>

</template>

<script>
export default {
    name: 'FooterPage',
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
